"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactCustomScrollbars = require("react-custom-scrollbars");
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _get = _interopRequireDefault(require("lodash/get"));
var _styles = require("@material-ui/core/styles");
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _ResizeDetect = require("../../../../../Shared/HOCs/ResizeDetect/ResizeDetect");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _withWidth = _interopRequireWildcard(require("@material-ui/core/withWidth"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = exports.styles = function styles(theme) {
  var _thumbnailCarouselWra, _dots, _wrapContainer;
  return {
    thumbnailCarouselWrapper: (_thumbnailCarouselWra = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingBottom: 16
    }, _defineProperty(_thumbnailCarouselWra, theme.breakpoints.down('xs'), {
      paddingBottom: '0'
    }), _defineProperty(_thumbnailCarouselWra, theme.breakpoints.between('sm', 'md'), {
      maxWidth: 300,
      margin: '0 auto'
    }), _thumbnailCarouselWra),
    fullSizeCarouselWrapper: {
      width: '100%',
      minWidth: 90,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    arrowScrollIcon: {
      '&:hover': {
        cursor: 'pointer',
        fontWeight: 'bold'
      }
    },
    designerThumbnail: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      '& img': {
        boxSizing: 'border-box',
        height: 70,
        maxWidth: 70,
        cursor: 'pointer',
        objectFit: 'cover',
        '&:hover': {
          cursor: 'pointer'
        }
      }
    },
    activeThumbnail: {
      border: '2px solid ' + theme.palette.primary.main,
      borderRadius: '4px'
    },
    inactiveThumbnail: {
      border: '1px solid #C4C4C4',
      borderRadius: '4px'
    },
    dots: (_dots = {
      position: 'inherit',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      maxHeight: 70,
      minHeight: 70,
      flexWrap: 'wrap',
      overflow: 'auto'
    }, _defineProperty(_dots, theme.breakpoints.down('sm'), {
      textAlign: 'initial'
    }), _defineProperty(_dots, theme.breakpoints.down('xs'), {
      maxHeight: 50,
      minHeight: 50,
      bottom: '0',
      textAlign: 'center',
      alignItems: 'center'
    }), _dots),
    thumbnailImageContainer: {
      height: 75,
      width: 75,
      paddingRight: 6,
      boxSizing: 'border-box',
      borderRadius: '4px'
    },
    dotContainer: {
      height: 40,
      width: 40,
      marginRight: '8px',
      '&.wrap-container': (_wrapContainer = {
        marginRight: 0,
        height: 32,
        width: 32,
        marginTop: 8
      }, _defineProperty(_wrapContainer, theme.breakpoints.down('sm'), {
        height: 20,
        width: 28,
        marginTop: 5
      }), _defineProperty(_wrapContainer, '& > div', {
        margin: 0
      }), _wrapContainer),
      '& > div': {
        textIndent: 1,
        color: '#FFFFFF',
        fontSize: '12px',
        lineHeight: '20px',
        textAlign: 'center',
        margin: '10px',
        cursor: 'pointer',
        height: 20,
        width: 20,
        borderRadius: '50%',
        display: 'inline-block',
        transition: 'background-color 0.6s ease'
      },
      '&:last-child': {
        marginRight: 0
      }
    },
    inactiveDotMode: {
      backgroundColor: '#D8D8D8'
    },
    activeDotMode: {
      backgroundColor: '#757575'
    }
  };
};
var Thumbnail = /*#__PURE__*/function (_React$Component) {
  _inherits(Thumbnail, _React$Component);
  var _super = _createSuper(Thumbnail);
  function Thumbnail() {
    var _this;
    _classCallCheck(this, Thumbnail);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isScrollingAvailable: true,
      availableWidth: 0
    });
    _defineProperty(_assertThisInitialized(_this), "scrollbars", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "thumbnailCarouselWrapperRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "onThumbnailClick", function (thumbnails, thumbnail) {
      return function () {
        if ((0, _isFunction["default"])(_this.props.thumbnailChange)) {
          _this.props.thumbnailChange(thumbnails, thumbnail.thumbnailImage, !thumbnail.active);
        }
      };
    });
    _defineProperty(_assertThisInitialized(_this), "updateScrollingAvailable", function () {
      if (_this.scrollbars && _this.scrollbars.current !== null) {
        var _this$scrollbars$curr = _this.scrollbars.current.getValues(),
          scrollWidth = _this$scrollbars$curr.scrollWidth,
          clientWidth = _this$scrollbars$curr.clientWidth;
        var isScrollingAvailable = _this.state.isScrollingAvailable;
        var nextIsScrollingAvailable = scrollWidth - clientWidth > 0;
        if (nextIsScrollingAvailable !== isScrollingAvailable) {
          _this.setState({
            isScrollingAvailable: nextIsScrollingAvailable
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onScrollStop", function () {
      if (_this.scrollbars && _this.scrollbars.current !== null) {
        var scrollLeftValue = _this.scrollbars.current.getScrollLeft();
        var scrollWidth = _this.scrollbars.current.getScrollWidth();
        var childWidth = (0, _get["default"])(_this.scrollbars.current, 'view.children[0].children[0].clientWidth');
        var scrolledElements = Math.round(scrollLeftValue / childWidth);
        var scrollToValue = Math.ceil(scrolledElements * childWidth);
        if (scrollWidth - scrollLeftValue <= childWidth) {
          _this.scrollbars.current.scrollLeft(scrollWidth);
        } else {
          _this.scrollbars.current.scrollLeft(scrollToValue);
        }
      }
    });
    return _this;
  }
  _createClass(Thumbnail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateScrollingAvailable();
      this.calculateAvailableWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.updateScrollingAvailable();
      var size = this.props.size;
      if (size !== prevProps.size) {
        this.calculateAvailableWidth();
      }
    }
  }, {
    key: "calculateAvailableWidth",
    value: function calculateAvailableWidth() {
      if (this.scrollbars && this.scrollbars.current !== null) {
        var childWidth = (0, _get["default"])(this.scrollbars.current, 'view.children[0].children[0].clientWidth');
        var availableWidth = this.thumbnailCarouselWrapperRef.current.clientWidth - 40;
        var containerElements = Math.floor(availableWidth / childWidth);
        this.setState({
          availableWidth: Math.ceil(containerElements * childWidth)
        });
      }
    }
  }, {
    key: "handleClickLeftArrow",
    value: function handleClickLeftArrow() {
      this.scrollbars.current.scrollLeft(this.scrollbars.current.getScrollLeft() - this.scrollbars.current.view.children[0].children[0].clientWidth);
    }
  }, {
    key: "handleClickRightArrow",
    value: function handleClickRightArrow() {
      this.scrollbars.current.scrollLeft(this.scrollbars.current.getScrollLeft() + this.scrollbars.current.view.children[0].children[0].clientWidth);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        thumbnails = _this$props.thumbnails,
        selectedDesignViewIdentifier = _this$props.selectedDesignViewIdentifier,
        classes = _this$props.classes,
        onThumbnailClick = _this$props.onThumbnailClick,
        previewOpen = _this$props.previewOpen,
        scrollbarHeight = _this$props.scrollbarHeight,
        width = _this$props.width;
      var _this$state = this.state,
        isScrollingAvailable = _this$state.isScrollingAvailable,
        availableWidth = _this$state.availableWidth;
      var items = thumbnails.items,
        dotMode = thumbnails.dotMode;
      var isSmallScreen = (0, _withWidth.isWidthDown)('md', width);
      if (items && items.length <= 1) {
        return null;
      }
      if (dotMode || isSmallScreen) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.dots
        }, items && items.map(function (thumbnail, index) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(classes.dotContainer, " ").concat(isSmallScreen ? 'wrap-container' : ''),
            key: thumbnail.identifier
          }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
            component: "div",
            className: selectedDesignViewIdentifier === thumbnail.identifier ? classes.activeDotMode : classes.inactiveDotMode,
            onClick: function onClick() {
              return onThumbnailClick(thumbnail.identifier);
            }
          }, index + 1));
        }));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: previewOpen ? classes.fullSizeCarouselWrapper : classes.thumbnailCarouselWrapper,
        ref: this.thumbnailCarouselWrapperRef
      }, isScrollingAvailable && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        onClick: this.handleClickLeftArrow.bind(this),
        className: classes.arrowScrollIcon
      }, "keyboard_arrow_left"), /*#__PURE__*/_react["default"].createElement(_reactCustomScrollbars.Scrollbars, {
        style: {
          height: scrollbarHeight || 84,
          width: availableWidth
        },
        autoHide: true,
        ref: this.scrollbars,
        onScrollStop: this.onScrollStop
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.designerThumbnail,
        style: {
          justifyContent: !isScrollingAvailable ? 'center' : 'initial'
        }
      }, items && items.map(function (thumbnail) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.thumbnailImageContainer,
          key: thumbnail.identifier,
          onClick: function onClick() {
            return onThumbnailClick(thumbnail.identifier);
          },
          value: thumbnail.identifier
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: thumbnail.thumbnailImage,
          alt: thumbnail.identifier,
          key: thumbnail.identifier,
          className: selectedDesignViewIdentifier === thumbnail.identifier ? classes.activeThumbnail : classes.inactiveThumbnail
        }));
      }))), isScrollingAvailable && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        onClick: this.handleClickRightArrow.bind(this),
        className: classes.arrowScrollIcon
      }, "keyboard_arrow_right"));
    }
  }]);
  return Thumbnail;
}(_react["default"].Component);
var VariantCarouselWithResizeDetectWrapper = (0, _ResizeDetect.withResizeDetectWrapper)((0, _withWidth["default"])({
  initialWidth: 'lg'
})(Thumbnail));
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'Thumbnail'
})(function (props) {
  return /*#__PURE__*/_react["default"].createElement(VariantCarouselWithResizeDetectWrapper, _extends({
    wrapperClassName: props.classes.resizeDetectWrapper
  }, props));
});